import Repository from "../../repository";

export default {
    GetRecently: (payload) => Repository.post(`/api/MoviePublish/GetRecently`, payload),
    GetDetail: (payload) => Repository.post(`/api/MoviePublish/GetDetail`, payload),
    GetRandom: (payload) => Repository.post(`/api/MoviePublish/GetRandom`, payload),
    GetTop: (payload) => Repository.post(`/api/MoviePublish/GetTop`, payload),
}
